export class HostingDatabase {

  public name: string;
  public username: string;
  public password: string;
  public path: string;

}

